import React from "react";

export namespace ResultIcons {
  export function Success({
    width = 100,
    height = 100,
    ...rest
  }: {
    width?: number;
    height?: number;
    [key: string]: any;
  }) {
    return (
      <svg
        width={width}
        height={height}
        {...rest}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 49.6032C0 22.2222 22.2222 0 49.6032 0C76.9841 0 99.2064 22.2222 99.2064 49.6032C99.2064 76.9841 76.9841 99.2064 49.6032 99.2064C22.2222 99.2064 0 76.9841 0 49.6032ZM14.881 49.6032L39.6825 74.4048L84.3254 29.7619L77.3314 22.7183L39.6825 60.3671L21.875 42.6091L14.881 49.6032Z"
          fill="#3CC701"
        />
      </svg>
    );
  }
}
